// @ts-strict-ignore
import {AttrsSchema, Component, ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {promisifyModal} from 'common/components/modal/utils';

import {template} from './template';
import css from './index.inline.styl';

type TutorialVideoModalState = {
  isModalOpen: boolean;
};

interface TutorialVideoModalAttrs {
  'custom-url': string;
  height: number;
  width: number;
  title: string;
}

export class TutorialVideoModal extends Component<TutorialVideoModalState, EmptyObj> {
  static get attrsSchema(): AttrsSchema<TutorialVideoModalAttrs> {
    return {
      'custom-url': {
        type: `string`,
        description: `custom url for tutorial video, if this is set, short will be ignored`,
      },
      width: {
        type: `number`,
      },
      height: {
        type: `number`,
      },
      title: {type: `string`},
    };
  }
  get config(): ConfigOptions<TutorialVideoModalState> {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        isModalOpen: true,
      },
      helpers: {
        closeModalHandler: () => {
          this.update({isModalOpen: false});
        },
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();

    // hide spinner when iframe loads
    const shadowRoot = document.getElementsByTagName(`mp-tutorial-video-modal`)[0].shadowRoot;
    const iframeEl = shadowRoot.getElementById(`tutorial-iframe`);
    const spinnerEl = shadowRoot.getElementById(`tutorial-spinner`);
    iframeEl.addEventListener(`load`, () => {
      spinnerEl.style.display = `none`;
    });
  }
}

export const TutorialVideoModalEl = defineAndMakeJsxFactory(`mp-tutorial-video-modal`, TutorialVideoModal);

export const TutorialVideoModalReact = panel2react(`mp-tutorial-video-modal`, TutorialVideoModal);

export const openMediaModal = (onErrorMessage: (ev: CustomEvent) => void, attrs = {}) => {
  return promisifyModal({
    tagName: `mp-tutorial-video-modal`,
    attrs,
    closeEvents: [`error`],
    closeHandler: (ev) => {
      if (ev.type === `error`) {
        onErrorMessage(ev);
      }
    },
  });
};
